export function clip(num: number, min: number, max: number){
  return Math.max(min, Math.min(max, num))
}

export function unique<T>(array: T[]): T[]{
  return Array.from(new Set(array))
}